import { convertFoxApiDateToStr } from "../../../../containers/Reservation/fox-reservation/fox-res-helper";
import moment from "moment";

export const FoxCustomerInsurance = function (data) {
    if (!data) data = {};
    this.insuranceCarrier = data.insuranceCarrier || null;
    this.insuranceVerified = data.insuranceVerified || false;
    this.insuranceExpirationDate = data.insuranceExpirationDate ? data.insuranceExpirationDate:null;
    this.policyNumber = data.policyNumber || null;
};